/* eslint-disable react/no-children-prop */
import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Fab from '@material-ui/core/Fab';
import ExportIcon from 'mdi-react/FormatListBulletedSquareIcon';
import { Link } from 'react-router-dom';

import SnackBar from '../SimpleSnackBar';
import TrialAlert from '../payment/TrialAlert';
import QuickStartGuide from '../QuickStartGuide';
import { withStyles } from "@material-ui/core/styles";

import { Tooltip } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import EyeIcon from 'mdi-react/AccountOutlineIcon'; // or VisibilityIcon if you prefer
import LinearLoading from './../LinearLoading';

import SearchIcon from 'mdi-react/SearchIcon';
import ResetIcon from 'mdi-react/AutorenewIcon';
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon';
import DeleteIcon from 'mdi-react/DeleteIcon';
import AccountCircleOutlineIcon from 'mdi-react/AccountCircleOutlineIcon';
import {
  Col, Container, Row, Card, CardBody, Badge, Table,
  Modal, ModalHeader, ModalBody, ModalFooter, ButtonToolbar
} from 'reactstrap';
import { _axiosCall } from '../../helpers/apicalls';
import classNames from 'classnames';
import CalloutBanner from '../CalloutBanner';

import {
  _capitalizeText,
  _formatNumber,
  searchBarStyles
} from '../../helpers/utils';

// IMPORTANT: adjust this import to your actual path
import SkipTraceUnifiedModal from './SkipTraceUnifiedModal';
import {formatAddress} from './skipTraceMatchUtils';

const apiUrl = process.env.API_ROOT;

const styles = {
	fab: {
		fontWeight: 600,
		background: "#780F9E",
		width: 200,
		"&.Mui-disabled": {
			color: "#F5F7FA",
			background: "#DBE0E8 !important",
		},
		"&:hover": {
			background: "#9600BF",
		},
	},
};

function SavedSkipTracesSearchBar(props) {
  const classes = searchBarStyles();
  const timeoutRef = React.useRef(null);

  var onKeyUp = function (e) {
	if (timeoutRef.current) clearTimeout(timeoutRef.current);

	var v = (e && e.target) ? e.target.value : '';
	timeoutRef.current = setTimeout(function () {
	  props.handleSearch(v);
	}, 600);
  };

  return (
	<div className={classes.grow} style={{ marginBottom: 10 }}>
	  <AppBar position="static" className={classes.appBar}>
		<Toolbar>
		  <div className={classes.search}>
			<div className={classes.searchIcon}>
			  <SearchIcon />
			</div>

			<InputBase
			  key={props.searchKey}
			  placeholder="Search by name or address"
			  classes={{ root: classes.inputRoot, input: classes.inputInput }}
			  inputProps={{ 'aria-label': 'search' }}
			  defaultValue={props.searchText}
			  onKeyUp={onKeyUp}
			/>
		  </div>

		  <div style={{ flexGrow: 1 }} />

		  {props.searchText ? (
			<Fragment>
			  <Tooltip title="Clear search">
				<IconButton
				  color="inherit"
				  className={'material-table__toolbar-button'}
				  onClick={props.resetSearch}
				>
				  <CloseCircleOutlineIcon />
				</IconButton>
			  </Tooltip>

			  <Tooltip title="Refresh">
				<IconButton
				  color="inherit"
				  className={'material-table__toolbar-button'}
				  onClick={props.refresh}
				>
				  <ResetIcon />
				</IconButton>
			  </Tooltip>
			</Fragment>
		  ) : null}
		</Toolbar>
	  </AppBar>
	</div>
  );
}

class SavedSkipTracesPage extends PureComponent {
  constructor(props) {
	super(props);

	this.state = {
	  snackShow: false,
	  snackMessage: '',
	  snackType: 'success',
	  snackDuration: 5000,

	  records: null,
	  page: 1,
	  limit: 25,
	  total: 0,

	  skip_trace_type: false,

	  searchText: '',
	  searchKey: 0,

	  detailOpen: false,
	  selected: null,
	  confirmRemoveOpen: false,
	  confirmRemoveRow: null,
	  confirmRemoveLoading: false,
	  
	  exportLoading: false,
	  listLoading: false,
	  entityFilter: 'all', // 'all' | 'people' | 'company'
	};

	this._getSaved = this._getSaved.bind(this);
	this._openDetail = this._openDetail.bind(this);
	this._closeDetail = this._closeDetail.bind(this);

	this._handleSearch = this._handleSearch.bind(this);
	this._resetSearch = this._resetSearch.bind(this);
	this._removeSaved = this._removeSaved.bind(this);
	
	this._openRemoveConfirm = this._openRemoveConfirm.bind(this);
	this._toggleRemoveConfirm = this._toggleRemoveConfirm.bind(this);
	this._confirmRemove = this._confirmRemove.bind(this);
	
	this._exportCSV = this._exportCSV.bind(this);

	this._openFromUrl = this._openFromUrl.bind(this);
	this._getRecordIdFromUrl = this._getRecordIdFromUrl.bind(this);
  }


  _getRecordIdFromUrl() {
	// Supports either react-router params or a trailing path segment, e.g. /saved-skip-traces/<record_id>
	var p = this.props || {};
	var matchId = p.match && p.match.params ? (p.match.params.record_id || p.match.params.id) : null;
	if (matchId) return String(matchId);

	var pathname = (p.location && p.location.pathname) ? String(p.location.pathname) : '';
	if (!pathname) return null;

	var parts = pathname.split('/').filter(Boolean);
	if (!parts.length) return null;

	var last = parts[parts.length - 1];
	// Mongo ObjectId style
	if (/^[a-f0-9]{24}$/i.test(last)) return last;

	return null;
  }

  _openFromUrl() {
	var record_id = this._getRecordIdFromUrl();
	if (!record_id) return;

	// Avoid re-opening on state changes
	if (this._openedFromUrl === record_id) return;
	this._openedFromUrl = record_id;

	var user = this.props.user || {};
	var user_key = user.id || user.user_key || user.sub;

	if (!user_key) return;

	var req = {
	  url: apiUrl + '/skip/skip-trace-saved/get',
	  method: 'post',
	  query: {
		user_key: user_key,
		record_id: record_id
	  }
	};

	this.setState({
	  snackShow: true,
	  snackType: 'info',
	  snackMessage: 'Opening saved contact...',
	  snackDuration: 2500
	});

	_axiosCall(req)
	  .then((res) => {
		if (res && res.found && res.record) {
		  var row = res.record;

		  // Set search to roughly match what the user is seeing (optional),
		  // then open the detail modal immediately.
		  var identity = row.identity || {};
		  var fullName = identity.business_name ? identity.business_name : ((identity.first_name || '') + ' ' + (identity.last_name || '')).trim();
		  var addr = formatAddress(identity);
		  var searchText = (fullName || addr || '').trim();

		  this._openDetail(row);
		} else {
		  this.setState({
			snackShow: true,
			snackType: 'warning',
			snackMessage: 'Saved contact not found.',
			snackDuration: 5000
		  });
		}
	  })
	  .catch(() => {
		this.setState({
		  snackShow: true,
		  snackType: 'error',
		  snackMessage: 'Could not open saved contact.',
		  snackDuration: 5000
		});
	  });
  }


  componentDidMount() {
	this._getSaved();
	this._openFromUrl();
  }

  componentDidUpdate(prevProps, prevState) {
	if (
	  prevState.page !== this.state.page ||
	  prevState.limit !== this.state.limit ||
	  prevState.skip_trace_type !== this.state.skip_trace_type ||
	  prevState.searchText !== this.state.searchText
	) {
	  this._getSaved();
	}
  }
  
  _exportCSV() {
	var user = this.props.user || {};
	var user_key = user.id || user.user_key || user.sub;
  
	if (!user_key) {
	  this.setState({
		snackShow: true,
		snackType: 'error',
		snackMessage: 'Missing user id.',
		snackDuration: 5000
	  });
	  return;
	}
  
	var skip_trace_type = this.state.skip_trace_type;
	var search = (this.state.searchText || '').trim() || undefined;
  
	this.setState({ exportLoading: true });
  
	var payload = {
	  query: {
		user_key: user_key,
		skip_trace_type: skip_trace_type || undefined,
		search: search,
		app_source: 'mp-pipe'
	  }
	};

	fetch(apiUrl + '/skip/skip-trace-saved/export', {
	  method: 'POST',
	  credentials: 'include',
	  headers: { 'Content-Type': 'application/json' },
	  body: JSON.stringify(payload)
	})
	  .then(function (r) {
		if (!r.ok) throw new Error('export_failed');
		return r.blob();
	  })
	  .then(function (blob) {
		var url = window.URL.createObjectURL(blob);
		var a = document.createElement('a');
		a.href = url;
		a.download = 'contacts_export.csv';
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
  
		this.setState({
		  exportLoading: false,
		  snackShow: true,
		  snackType: 'success',
		  snackMessage: 'CSV exported.',
		  snackDuration: 4000
		});
	  }.bind(this))
	  .catch(function () {
		this.setState({
		  exportLoading: false,
		  snackShow: true,
		  snackType: 'error',
		  snackMessage: 'Could not export CSV.',
		  snackDuration: 5000
		});
	  }.bind(this));
  }

  
  _openRemoveConfirm(row, e) {
	if (e && e.stopPropagation) e.stopPropagation();
	this.setState({
	  confirmRemoveOpen: true,
	  confirmRemoveRow: row || null,
	  confirmRemoveLoading: false
	});
  }
  
  _toggleRemoveConfirm(e) {
	if (e && e.stopPropagation) e.stopPropagation();
	this.setState(function (prev) {
	  return {
		confirmRemoveOpen: !prev.confirmRemoveOpen,
		confirmRemoveRow: prev.confirmRemoveOpen ? null : prev.confirmRemoveRow,
		confirmRemoveLoading: false
	  };
	});
  }
  
  _confirmRemove(e) {
	if (e && e.preventDefault) e.preventDefault();
	if (e && e.stopPropagation) e.stopPropagation();
  
	var row = this.state.confirmRemoveRow;
	if (!row || this.state.confirmRemoveLoading) return;
  
	this.setState({ confirmRemoveLoading: true });
  
	// Uses your existing API logic
	this._removeSaved(row, null);
  }



  _handleSearch(searchText) {
	this.setState({
	  searchText: (typeof searchText === 'string') ? searchText : '',
	  page: 1
	});
  }

  _resetSearch() {
	this.setState(function (prev) {
	  return {
		searchText: '',
		page: 1,
		searchKey: (prev.searchKey || 0) + 1
	  };
	});
  }

 _getSaved() {
   var user = this.props.user || {};
   var user_key = user.id || user.user_key || user.sub;
 
   var page = this.state.page;
   var limit = this.state.limit;
   var skip_trace_type = this.state.skip_trace_type;
 
   var search = (this.state.searchText || '').trim() || undefined;
 
   var req = {
	 url: apiUrl + '/skip/skip-trace-saved/list',
	 method: 'post',
	 query: {
	   query: {
		 user_key: user_key,
		 skip_trace_type: skip_trace_type || undefined,
		 search: search,
		 app_source: 'mp-pipe'
	   },
	   page: page,
	   limit: limit
	 }
   };
 
   this.setState({ listLoading: true });
 
   return _axiosCall(req)
	 .then((res) => {
	   if (res && res.results && res.results.length >= 0) {
		 this.setState({
		   records: res.results,
		   total: res.total || 0,
		   listLoading: false
		 });
	   } else {
		 this.setState({ records: [], total: 0, listLoading: false });
	   }
	 })
	 .catch((error) => {
	   console.log('_getSaved error', error);
	   this.setState({ records: [], total: 0, listLoading: false });
	 });
 }



  _openDetail(row) {
	var self = this;
	this.setState({ selected: row, detailOpen: false }, function () {
	  self.setState({ detailOpen: true });
	});
  }

  _closeDetail() {
	this.setState({ detailOpen: false, selected: null });
  }

  _removeSaved(row, e) {
	if (e && e.stopPropagation) e.stopPropagation();
  
	var user = this.props.user || {};
	  var user_key = user.id || user.user_key || user.sub;
	
	  var record_id = row && row._id ? row._id : null;
	  if (!record_id) return; // or show toast
	
	  var req = {
		url: apiUrl + '/skip/skip-trace-saved/remove',
		method: 'post',
		query: {
		  user_key: user_key,
		  record_id: record_id
		}
	  };
  
	_axiosCall(req)
	  .then(() => {
		this.setState({
		  snackShow: true,
		  snackType: 'success',
		  snackMessage: 'Removed from saved list.',
		  confirmRemoveOpen: false,
		  confirmRemoveRow: null,
		  confirmRemoveLoading: false
		});
	
		if ((this.state.records || []).length <= 1 && this.state.page > 1) {
		  this.setState({ page: this.state.page - 1 });
		} else {
		  this._getSaved();
		}
	  })
	  .catch(() => {
		this.setState({
		  snackShow: true,
		  snackType: 'error',
		  snackMessage: 'Could not remove saved contact.',
		  confirmRemoveLoading: false
		});
	  });

  }


  render() {
	var records = this.state.records || [];
	
	
	var page = this.state.page;
	var limit = this.state.limit;
	var total = this.state.total;

	var detailOpen = this.state.detailOpen;
	var selected = this.state.selected;
	var selectedType =
	  (selected && (selected.skip_trace_type || selected.premium_service_id)) || null;
	var selectedIdentity = selected && selected.identity ? selected.identity : {};
	var selectedName = ['acirs_analyze', 'company_basic', 'company_advanced'].indexOf(selectedType)>-1 ? selectedIdentity.business_name : ((selectedIdentity.first_name || '') + ' ' + (selectedIdentity.last_name || '')).trim();

	var types = [
	  { key: 'contact', label: 'Contact' },
	  { key: 'profile', label: 'profile' }
	];
	
	types = [];

	var skip_trace_type = this.state.skip_trace_type;

	var snackShow = this.state.snackShow;
	var snackMessage = this.state.snackMessage;
	var snackDuration = this.state.snackDuration;
	var snackType = this.state.snackType;

	return (
	  <Container fluid className="dashboard">
		<TrialAlert {...this.props} />

		<SnackBar
		  snackShow={snackShow}
		  snackClose={() => this.setState({ snackShow: false })}
		  snackMessage={snackMessage}
		  snackDuration={snackDuration}
		  snackType={snackType}
		/>
		{records && records.length > 0 ?
		<div style={{ position: 'fixed', bottom: 90, right: 100, zIndex: 9999 }}>
			<Tooltip title={'Export Contact List'}>
				<Fab
					variant="extended"
					size="medium"
					color="secondary"
					aria-label="add"
					style={{ fontWeight: 400, background: '#780F9E' }}
					onClick={this._exportCSV}
					disabled={this.state.exportLoading ? true : false}
					className={this.props.classes.fab}
				>
					<ExportIcon style={{ marginRight: 5 }} /> { }{this.state.exportLoading ? 'Exporting...' : 'Export Contact Info (CSV)'}
				</Fab>
			</Tooltip>
		</div>:null}

		<Row>
		  <Col md={12}>
			<h3 className="page-title">{'My Contacts'}</h3>
			<h3 className="page-subhead subhead">{'Access contacts you have previously researched.'}</h3>
		  </Col>
		</Row>

	<CalloutBanner
	  storageKey="mp_owner_outreach_banner_v1"
	  variant="purple"
	>
	  {function () {
		return (
		  <div className="d-flex justify-content-between align-items-center flex-wrap">
			<div>
			  <p className="callout-banner-title">
				<img
				  src="https://marketproof.com/images/new-red.png"
				  alt=""
				  style={{ marginRight: 6 }}
				/>
				Contact Info and Insights
			  </p>

			  <p className="callout-banner-sub-title mb-2">
				Contact Lookup now includes email and phone, along with work history
				and education, to enable more effective outreach.
			  </p>
			</div>
	 
			<div className="align-items-center mt-2 text-right">
			  <a
				href="http://help.marketproof.com/en/articles/13441323-owner-outreach-introduction"
				target="_blank"
				rel="noopener noreferrer"
				className="btn btn-primary mb-2 callout-banner-btn"
			  >
				Learn more
			  </a>
	
			</div>
		  </div>
		);
	  }}
	</CalloutBanner>

		<Row>
		  <Col md={12}>
			<Card>
			  <CardBody>
				<Row style={{ marginBottom: 10 }}>
				  <Col md={12}>
					<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
					  <div>
						{types.map(function (t) {
						  var active = t.key === skip_trace_type;
						  return (
							<Button
							  key={t.key}
							  color={active ? 'primary' : 'secondary'}
							  style={{ marginRight: 10, marginBottom: 10 }}
							  onClick={() => this.setState({ skip_trace_type: t.key, page: 1 })}
							>
							  {_capitalizeText(t.label)}
							</Button>
						  );
						}.bind(this))}
						
					
					  </div>

					  <div style={{ paddingTop: 6 }}>
						<Badge color="secondary">{'Total Contacts'}{total > 0 ? (' (' + total + ')') : null}</Badge>
					  </div>
					</div>
				  </Col>
				</Row>

				<SavedSkipTracesSearchBar
				  searchText={this.state.searchText}
				  searchKey={this.state.searchKey}
				  handleSearch={this._handleSearch}
				  resetSearch={this._resetSearch}
				  refresh={this._getSaved}
				/>
				
				


				<Table striped responsive>
				  <thead>
					<tr>
					  <th style={{ minWidth: 120 }}></th>
					  <th style={{ minWidth: 150 }}>Date</th>
					  <th style={{ minWidth: 220 }}>Name</th>
					  {/* <th>Type</th>
					  <th>Credits</th> */}
					  <th style={{ minWidth: 240 }}>Address</th>
					  <th style={{ minWidth: 70 }}></th>
					</tr>
				  </thead>
				 
				  <tbody>
					{records && records.map(function (row) {
					  var identity = row.identity || {};
					  var fullName = identity.business_name ? identity.business_name : ((identity.first_name || '') + ' ' + (identity.last_name || '')).trim() || '--';
					  var address = formatAddress(identity)

					  var type = row.skip_trace_type || row.premium_service_id || '--';
					  var savedAt = row.updated_at || row.created_at || row.created_timestamp || null;

					  var creditsUsed = (typeof row.credits_used !== 'undefined' && row.credits_used !== null)
						? row.credits_used
						: '--';

					  var hasAI = row.data && row.data.ai_profile ? true : false;
					  
					  var isCompany = row.skip_trace_type.indexOf('company') > -1;

					  return (
						<tr
						  key={row._id || (fullName + ':' + address + ':' + type)}
						  onClick={(e) => { e.preventDefault(); this._openDetail(row); }}
						  style={{ cursor: 'pointer' }}
						>
						  {/* Replace Status with View button */}
						  <td style={{ whiteSpace: 'nowrap' }}>
							{isCompany && row.data && row.data.status && row.data.status != "done" ? 
							<div className={`skip-trace-status ${row.data.status}`}>{_capitalizeText(row.data.status)}</div>
							:
							<Tooltip title="View saved contact">
							  <Button
								onClick={(e) => { e.stopPropagation(); this._openDetail(row); }}
								variant="contained"
								size="small"
								color="secondary"
								className="buyersList__secondary-button"
								startIcon={<EyeIcon />}
							  >
								Details
							  </Button>
							</Tooltip>}

						  </td>

						  <td>{savedAt ? moment(savedAt).format('M/D/YYYY hh:mm A') : '--'}</td>

						  <td>
							{_capitalizeText(fullName)}
							<Tooltip title={'Includes AI Profile'}>
								<IconButton size={'small'} style={{ background: 'transparent' }}>
								  <span className="unit-type_badge skip-type-badge">{_capitalizeText(row.skip_trace_type.replace('_', ' '))}</span>
								</IconButton>
							  </Tooltip>
						  </td>

						  {/* <td>{_capitalizeText(String(type).replace(/_/g, ' '))}</td>

						  <td>{creditsUsed !== '--' ? (_formatNumber(creditsUsed) + ' Credits') : '--'}</td> */}

						  <td>{address}</td>

						  {/* Remove icon button */}
						  <td style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
							<Tooltip title={'Remove from Saved'}>
							  <IconButton
								color="inherit"
								className={'material-table__toolbar-button'}
								onClick={(e) => this._openRemoveConfirm(row, e)}
							  >
								<DeleteIcon />
							  </IconButton>
							</Tooltip>
						  </td>
						</tr>
					  );
					}.bind(this))}

					{(!this.state.listLoading && records !== null && records.length === 0) ? (
					 <tr>
					   <td colSpan={7} style={{ padding: 32, textAlign: 'center' }}>
						 <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
						   <AccountCircleOutlineIcon size={48} style={{ fontSize: 48, color: '#BFC4D1', marginBottom: 12 }} />
					 
						   <div style={{ fontSize:20, fontWeight: 600, marginBottom: 6 }}>
							 No Saved Contacts Yet
						   </div>

						   <div style={{ color: '#6F7785', maxWidth: 420, marginBottom: 16 }}>
							 Start a Contact Lookup to identify the right contacts, choose the best way to reach them, and tailor your message based on who they are.
						   </div>
					 	  <Button
								component={Link}
								  to="/contact-lookup"
								 variant="contained"
								 color="primary"
								 className="premium-miniCard__cta saved-skip-trace-empty-cta"
								 startIcon={<SearchIcon/>}
								 style={{width:250}}
							 >
								 Start Contact Lookup
							 </Button>
						  
						 </div>
					   </td>
					 </tr>

					) : null}
				  </tbody>
				</Table>
				
				{this.state.listLoading ? (
					<div style={{ margin: 10 }}>
					  <LinearLoading />
					</div>
				  ) : null}
			  </CardBody>
			</Card>
		  </Col>

		  {records && records.length > 0 ? (
			<Col md={12} lg={12}>
			  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px', width: '100%' }}>
				<Button
				  disabled={page <= 1}
				  onClick={() => this.setState(function (prev) { return { page: prev.page - 1 }; })}
				>
				  Prev
				</Button>

				<div style={{ paddingTop: '7px' }}>
				  {'Page '}{page}{' of '}{Math.max(1, Math.ceil(total / limit))}{' ('}{total}{' saved)'}
				</div>

				<Button
				  disabled={page >= Math.ceil(total / limit)}
				  onClick={() => this.setState(function (prev) { return { page: prev.page + 1 }; })}
				>
				  Next
				</Button>
			  </div>
			</Col>
		  ) : null}
		</Row>

		{/* Controlled modal: display saved record only */}
		{selected ? (
		  <SkipTraceUnifiedModal
			isOpen={detailOpen}
			onClose={this._closeDetail}
			triggerDisplay={selectedName || 'Saved Skip Trace'}
		
			// ensures modal renders person flow without borough check
			property={selected.data.property}
		
			first_name={selectedIdentity.first_name || ''}
			last_name={selectedIdentity.last_name || ''}
			address_1={selectedIdentity.address_1 || ''}
			address_2={selectedIdentity.address_2 || ''}
			city={selectedIdentity.city || ''}
			state={selectedIdentity.state || ''}
			zip={selectedIdentity.zip || ''}
		
			// ✅ RESTORED — this is the critical piece
			saved_record={selected}
		
			// keep existing behavior
			saved_skip_trace_type={selectedType}
		
			// hides trigger inside modal
			hideTrigger={true}
		  />
		) : null}
		
		{(() => {
		  var row = this.state.confirmRemoveRow || {};
		  var ident = row.identity || {};
		  var fullName = ((ident.first_name || '') + ' ' + (ident.last_name || '')).trim();
		  var label = fullName || 'this saved contact';
		  var loading = this.state.confirmRemoveLoading;
		
		  var modalClass = classNames({
			'modal-dialog--colored': false,
			'modal-dialog--header': true,
		  });
		
		  return (
			<Modal
			  isOpen={this.state.confirmRemoveOpen}
			  toggle={this._toggleRemoveConfirm}
			  modalClassName={'ltr-support'}
			  className={'modal-dialog--primary ' + modalClass}
			>
			  <div className="modal__header">
				<button
				  className="lnr lnr-cross modal__close-btn"
				  type="button"
				  onClick={this._toggleRemoveConfirm}
				/>
				<h4 className="text-modal modal__title">Remove Saved Contact</h4>
			  </div>
		
			  <div className="modal__body">
				<p>{'Remove '}{label}{' from your saved list?'}</p>
			  </div>
		
			  <ButtonToolbar className="modal__footer">
				<Tooltip title="Cancel">
				  <Button
					onClick={this._toggleRemoveConfirm}
					variant="outlined"
					style={{ marginRight: 10 }}
					disabled={loading}
				  >
					Cancel
				  </Button>
				</Tooltip>
		
				<Tooltip title="Remove from Saved">
				  <Button
					onClick={this._confirmRemove}
					variant="contained"
					color="primary"
					className="buyersList__primary-button"
					disabled={loading}
				  >
					{loading ? <span>Removing...</span> : <span>Remove</span>}
				  </Button>
				</Tooltip>
			  </ButtonToolbar>
			</Modal>
		  );
		})()}



	  </Container>
	);
  }
}

export default connect(function (state) {
  return { user: state.user };
})(withStyles(styles)(SavedSkipTracesPage));
